import { createKeyframe, emptyPalette } from './state.js';

// ================================================================
// CLAWD DEFAULT POSES
// ================================================================
export function createClawdDefaults() {
  const poses = {
    "default": {
      r1L: " \u2590", r1E: "\u259B\u2588\u2588\u2588\u259C", r1R: "\u258C",
      r2L: "\u259D\u259C", r2R: "\u259B\u2598",
    },
    "look-left": {
      r1L: " \u2590", r1E: "\u259F\u2588\u2588\u2588\u259F", r1R: "\u258C",
      r2L: "\u259D\u259C", r2R: "\u259B\u2598",
    },
    "look-right": {
      r1L: " \u2590", r1E: "\u2599\u2588\u2588\u2588\u2599", r1R: "\u258C",
      r2L: "\u259D\u259C", r2R: "\u259B\u2598",
    },
    "arms-up": {
      r1L: "\u2597\u259F", r1E: "\u259B\u2588\u2588\u2588\u259C", r1R: "\u2599\u2596",
      r2L: " \u259C", r2R: "\u259B ",
    },
  };
  const center = "\u2588\u2588\u2588\u2588\u2588";
  const feet   = "  \u2598\u2598 \u259D\u259D  ";

  const keyframes = {};
  const kfIds = {};

  for (const [name, p] of Object.entries(poses)) {
    const row1 = p.r1L + p.r1E + p.r1R;
    const row2 = p.r2L + center + p.r2R;
    const rows = [row1, row2, feet];
    const maxCols = Math.max(...rows.map(r => [...r].length));
    const numRows = rows.length;

    const kf = createKeyframe(name, numRows, maxCols);
    for (let r = 0; r < numRows; r++) {
      const chars = [...rows[r]];
      for (let c = 0; c < maxCols; c++) {
        kf.grid[r][c] = { char: chars[c] || " ", color: null };
      }
    }
    keyframes[kf.id] = kf;
    kfIds[name] = kf.id;
  }

  const sequence = [
    { pose: "default", duration: 800 },
    { pose: "look-left", duration: 500 },
    { pose: "look-left", duration: 500 },
    { pose: "default", duration: 300 },
    { pose: "look-right", duration: 500 },
    { pose: "look-right", duration: 500 },
    { pose: "default", duration: 300 },
    { pose: "arms-up", duration: 600 },
    { pose: "arms-up", duration: 600 },
    { pose: "default", duration: 400 },
  ];

  return {
    version: 1,
    gridSize: { rows: 3, cols: 9 },
    backgroundColor: "#012b36",
    fontSize: 48,
    activePalette: emptyPalette(),
    keyframes,
    sequences: [{
      name: "clawd-animation",
      steps: sequence.map(s => ({ keyframeId: kfIds[s.pose], duration: s.duration })),
      loop: true,
    }],
  };
}
